export * from './vr.component'